import React, { useState, useEffect } from 'react';
import { useMessagesSelected } from '../../hooks/useMessagesSelected';
import * as Util from '../../data/General';
import WhatsApp from '../html/WhatsApp';

const timer = 8200;

let TIMEOUT = null;
function ListMessages(props) {
  const {idMessage, idElement} = props;
  const [search, setSearch] = useState("");
  const [diff, setDiff] = useState(-1);
  const [placeholder, setPlaceholder] = useState("");
  const [isSendMessage, setIsSendMessage] = useState(false);
  const shopJson =  Util.getAdminShop();


  
  const [listMessages, setListMessages] = useState(Util.getLocalStorage("inboxs"));


  


  const callback = (data) => {
    let inbound = null;
    data && data.length > 0 && data.map((item) => {
      if(inbound === null && item.direction==="inbound"){
        inbound = item;
        return;
      }
    })
    if(inbound === null) {
      setIsSendMessage(false);
      setPlaceholder("Fuera de la ventana de mensajes");
    }else{
      const ahora = convertDate(new Date());
      const ultimaActualizacion = convertDate(new Date(inbound.createdAt));

      const diffMs = ahora - ultimaActualizacion;
      const diffHorasTotal = diffMs / (1000 * 60 * 60);

      if (diffHorasTotal > 24) {
        setIsSendMessage(false);
        setPlaceholder("Fuera de la ventana de mensajes");
      } else {
        // Calculamos horas y minutos restantes
        let horas = Math.floor(diffHorasTotal);
        let minutos = Math.floor((diffHorasTotal - horas) * 60);

        horas = 24 - horas;
        minutos = 60 - minutos;

        // Formateamos a 2 dígitos
        const horasStr = String(horas).padStart(2, "0");
        const minutosStr = String(minutos).padStart(2, "0");

        setIsSendMessage(true);
        setPlaceholder(`Tienes ${horasStr}:${minutosStr} para responder`);
      }
    }
    if(idElement){
      setTimeout(() => {
        scrollToMessage(idElement);
      }, 500);
    }
  }

  useEffect(() => {
    if(idElement){
      setTimeout(() => {
        scrollToMessage(idElement);
      }, 500);
    }
  },[idElement]);

  const scrollToMessage = (messageId) =>{
    const container = document.getElementById("content-messages");
    const message = document.getElementById(messageId);

    if (container && message) {
      message.scrollIntoView({
        behavior: "smooth",
        block: "center" // lo centra en el contenedor
      });
      message.classList.add("highlight");
    }
  }
  const {data, isLoad, sendMessageWhatsapp, refreshId, clear} = useMessagesSelected({ idMessage: idMessage, method:"GET", callback: callback})
  
   useEffect(() => {
      clearTimeout(TIMEOUT);
      TIMEOUT = setTimeout(function(){
        if (search !== ""){
          listMessages[idMessage] = search;
          Util.setLocalStorage("inboxs", listMessages);
        }else if(listMessages[idMessage]){
          delete listMessages[idMessage];
          Util.setLocalStorage("inboxs", listMessages);
        }
      }.bind(this), 900);
      
      return () => clearTimeout(TIMEOUT);
  },[search]);
  
  useEffect(() => {
    console.log("idMessage", idMessage);
    refreshId(idMessage);
    setSearch("");
    let textLocal = listMessages && listMessages[idMessage] ? listMessages[idMessage] : null;
    if(textLocal){
      setSearch(textLocal);
    }
    return () => {
      clear();
    }
  },[idMessage]);
  const getDate = (varDate) =>{
    if(varDate && typeof varDate === 'string'){
      const event = new Date(varDate);
        return new Intl.DateTimeFormat(window.paramRevie.language, { dateStyle: 'full', timeStyle: 'medium' }).format(event);
    }
    return "";
  }
    
  
  const sendMessage = () => {
    sendMessageWhatsapp(search);
    setSearch("");
  }

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault(); // evitar el salto de línea
      if(isSendMessage){
        sendMessage();
      }
    }
  };

 
    // Función para obtener un Date ajustado a la zona horaria
    const convertDate = (date) => {
        const zonaHoraria = shopJson && shopJson.timeZone ? shopJson.timeZone : "America/Mexico_City";
        const fechaUTC = new Date(date);
        // Obtenemos las partes en hora de México
        const partes = new Intl.DateTimeFormat("en-US", {
            timeZone: zonaHoraria,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false
        }).formatToParts(fechaUTC);

        const get = (type) => parseInt(partes.find(p => p.type === type).value, 10);

        // Creamos un Date local a México
        return new Date(
            get("year"),
            get("month") - 1,
            get("day"),
            get("hour"),
            get("minute"),
            get("second")
        );
    }
  return (
    <>
      {isLoad ? <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div> : null}
      <div className='content-messages' id="content-messages">
        {data && data.length > 0 && data.map((item) => {
            let content = JSON.parse(item.contentData.content);
            let message = {
              body: item.body ? item.body : "", 
              createdAt: getDate(item.createdAt),
              id:item.id
            }
            if (item.mediaContentType === "image/jpeg"){  
              message = {
                body: "", 
                mediaurl: item.body,
                createdAt: getDate(item.createdAt),
                id:item.id
              }
            }else if(item.mediaContentType === "audio/ogg"){
              message = {
                body: "", 
                audiourl: item.body,
                createdAt: getDate(item.createdAt),
                id:item.id
              }
            }else if(content && content.types && content.types["whatsapp/card"]){
              message = {
                body: item.body && item.body !== "" ? item.body : content.types["whatsapp/card"] && content.types["whatsapp/card"].body ? content.types["whatsapp/card"].body : "", 
                footer: content.types["footer"] ? content.types["footer"] : "", 
                mediaurl: content.types["whatsapp/card"] && content.types["whatsapp/card"]["media"].length > 0 ? content.types["whatsapp/card"]["media"][0] : "", 
                buttontext: content.types["actions"] && content.types["actions"].length > 0 ? content.types["actions"][0].title : "", 
                name: "", 
                mediatext:"",
                cards: content.actions,
                createdAt: getDate(item.createdAt),
                id:item.id
              };
            }
            return (
            <div key={item.id} className={`message ${item.direction}`}>
              <WhatsApp 
                message={message} 
              />
            </div>
            );
          
      })}
        
      </div>
      <div className='input-messages'>
        <div className='button-messages'>
          <textarea type="text" disabled={!isSendMessage} placeholder={placeholder} onKeyDown={handleKeyDown} value={search} onChange={(e) => setSearch(e.target.value)}/>
          <button disabled={!isSendMessage} onClick={() => sendMessage()}>
            <svg viewBox="0 0 24 24" height="24" width="24" preserveAspectRatio="xMidYMid meet"  fill="none">
              <path d="M5.4 19.425C5.06667 19.5583 4.75 19.5291 4.45 19.3375C4.15 19.1458 4 18.8666 4 18.5V14L12 12L4 9.99997V5.49997C4 5.1333 4.15 4.85414 4.45 4.66247C4.75 4.4708 5.06667 4.44164 5.4 4.57497L20.8 11.075C21.2167 11.2583 21.425 11.5666 21.425 12C21.425 12.4333 21.2167 12.7416 20.8 12.925L5.4 19.425Z" fill="currentColor"></path>
            </svg>
          </button>
        </div>
      </div>
    </>
);
}

export default ListMessages;